import DialogAlert from "components/DialogAlert/DialogAlert";
import errorImage1 from "img/error_image_1.svg";
import { Container } from "./styles";
import ErrorStack from "components/ErrorsStack/ErrorsStack";
import { ParagraphSection, TitleSection } from "components/styles";
import CustomButton from "components/CustomButton/CustomButton";

const DialogShowErrorInfoAtTheEndOfCreation = ({
    dialogShow,
    errorStack,
    quantities
}) => {
    return (
        <DialogAlert 
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}>
            <Container>
                <img src={errorImage1} alt="Imagen de error"/>
                <TitleSection 
                    width="100%"
                    textAlign="center">
                    Han ocurrido algunos errores al crear los refuerzos
                </TitleSection>
                <ParagraphSection margin="0 0 15px 0">
                    Se lograron agregar {quantities.ok} registro(s) y se encontraron {quantities.error} registro(s) con error.
                </ParagraphSection>
                <ErrorStack 
                    stack={errorStack.map(({ row, tutorId, message }) => ({
                        row, 
                        message: `${tutorId ? `Tutor: ${tutorId} - `: "" }${message}`
                    }))}
                    complete/>
                <CustomButton text="Cerrar" onClick={() => dialogShow.set(false)}/>
            </Container>
        </DialogAlert>
    );
}

export default DialogShowErrorInfoAtTheEndOfCreation;